// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.ApproveInvoiceRequest */
/* istanbul ignore next */
@GandalfModel
export class ApproveInvoiceRequest extends GandalfModelBase {

	@GandalfLabel('AssignFeeSchedule')
	@GandalfValidator({ notNull: { message: 'AssignFeeSchedule is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	assignFeeSchedule!: boolean;

	@GandalfLabel('Invoice')
	@GandalfValidator({ notNull: { message: 'Invoice is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	invoiceId!: number;

}
